import { FC } from 'react';

import Icon from './image.svg';

export const CoinbaseLogo: FC = () => <img src={Icon} alt="coinbase logo" />;
